import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MailStateService } from '../../services/mail-state.service';

@Component({
  selector: 'app-mail-subscribe',
  templateUrl: './mail-subscribe.page.html',
  styleUrls: ['./mail-subscribe.page.css']
})
export class MailSubscribePageComponent implements OnInit {

  constructor(
    private router: Router,
    private mailStateService: MailStateService,
  ) {
    setTimeout(
      () => {
        this.mailStateService.reset();
        this.router.navigate(['']);
      },
      5000);
  }

  ngOnInit() {
  }

}
